import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_RuntimeSmartDoc } from '@app/advisor-shared';
import { sortArray } from '@nu-art/ts-common';
import { SmartDocsType_Enum } from '@app/advisor-shared';
import { sendValidateCacheMessage } from '../../../index.js';
import { ModuleFE_BaseAdvisorRuntime } from '../../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { ModuleFE_AdvisorSession } from '../../advisor-session/index.js';
export const dispatch_onRuntimeSmartDocUpdated = new ThunderDispatcherV3('__onRuntimeSmartDocsUpdated');
export class ModuleFE_RuntimeSmartDoc_Class extends ModuleFE_BaseAdvisorRuntime {
    _v1;
    __validateCache() {
        const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
        const invalidSmartDocs = this.cache.filter(smartDoc => smartDoc.encounterId !== encounterId);
        const moduleName = this.getName();
        if (!invalidSmartDocs.length)
            return this.logDebug(`${moduleName} cache is valid`);
        this.logErrorBold(`${moduleName} has invalid data in cache`, invalidSmartDocs);
        return sendValidateCacheMessage(invalidSmartDocs, moduleName);
    }
    constructor() {
        super(DBDef_RuntimeSmartDoc, dispatch_onRuntimeSmartDocUpdated);
        this._v1 = {};
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.encounterFilter);
    }
    getAllNotes = () => sortArray(this.cache.filter(note => note.smartDocType !== SmartDocsType_Enum.SUMMARY), item => item.timeCreated, true);
    getSummaryNote = () => {
        // return latest summery produced
        return sortArray(this.cache.filter(note => note.smartDocType === SmartDocsType_Enum.SUMMARY), item => item.timeCreated, true)[0];
    };
}
export const ModuleFE_RuntimeSmartDoc = new ModuleFE_RuntimeSmartDoc_Class();
//# sourceMappingURL=ModuleFE_RuntimeSmartDoc.js.map